/**
 * Mirror of the backend's `PayloadTypeCodes` object
 * (`optisel-business/.../optiselevent/PayloadTypeCodes.kt`).
 *
 * The backend ships each payload to the API with a "typeCode" discriminator string that
 * `ShowOptiselEventPage` branches on. Two families of codes exist:
 *
 *  - Codes identical to the Xodus-persistence discriminator (most payloads). These are
 *    pinned forever because historical records carry them.
 *
 *  - Codes that differ from persistence because the backend reshapes the payload into a
 *    different DTO via `toApiJson()`. Currently: `DatasheetPayload_v1` ships as
 *    `typescript_InstalledFanDatasheet`, `SelectionCriteriaPayload_v1` ships as
 *    `typescript_SelectionRequestJson`. These "api" codes may evolve together with the
 *    frontend in one deploy — but they must never collide with a persistence code.
 *
 * When adding a new payload: add a constant here, add the matching render branch in
 * `ShowOptiselEventPage.tsx`, and mirror both in the backend `PayloadTypeCodes` object.
 */
export const PayloadApiTypeCodes = {
    MECHANICAL_PART_LIST: "mechanical-part-list",
    LOGS: "logs",
    PHYSICAL_PARAMETERS: "physical-parameters",
    ERROR_MESSAGE: "error-message",
    SELECTION_RESULTS: "selection-results",
    MECHANICAL_ASSEMBLY_RESULTS: "mechanical-assembly-results",
    SIMPLE_JSON_OBJECT: "simple-json-object",
    IMPELLER_ASSEMBLY_JSON: "impeller-assembly-json",
    BINARY_PDF_DATASHEET_V2: "BinaryPdfDatasheetPayload_v2",
    DRIVEWORKS_XLS_V1: "DriveWorksXlsPayload_v1",
    INSTALLED_FAN_DATASHEET: "typescript_InstalledFanDatasheet",
    SELECTION_REQUEST: "typescript_SelectionRequestJson",
    DATASHEET_COMMENT_V1: "DatasheetCommentPayload_v1",
} as const;
